import Header from './components/Header';
import HeroSection from './components/HeroSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="relative min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <TopicsSection />
        <AboutSection />
        <IndexSection />
        <UpdatesSection />
        <RankingSection />
        <ContactSection />
        <CardsSection />
        <FaqSection />
        <CommentsSection />
        <CarouselSection />
        <AppSection />
        <MediaSection />
        <FeaturesSection />
      </main>
      <Footer />
    </div>
  );
}